module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"enable":"Enable","disable":"Disable","connected":"Connected","importVacanciesFromHH":"Import vacancies from HeadHunter","importVacanciesFromHHShort":"Import vacancies from HH"}}')
  delete Component.options._Ctor
}
